import React, { useRef, useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import * as d3 from 'd3'
import { Alert, message } from 'antd'

import { importGiftCards } from '../services'
import { handleError } from '../../../helpers'

export default function ImportGiftCardsModal({ visible, onClose, reload }) {
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState(null)
	const [results, setResults] = useState({})

	const uploadFile = useRef(null)
	
	const handleFiles = () => {
		(async () => {
			const text = await uploadFile.current.files[0].text()
			if(uploadFile.current.files[0].type !== 'text/csv')
				return message.warning('Favor ingresar únicamente archivos .csv')
				
			setData(d3.csvParse(text))
		})()
	}

	const handleSubmit = () => {
		setLoading(true)
		importGiftCards({ type:'birthday', rows: JSON.stringify(data) })
			.then(res => {
				message.success(res.data.message)
				setResults(res.data.data)
				reload()
			})
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<Modal isOpen={visible}>
			<ModalHeader toggle={onClose}>Importar Bonos de Regalo</ModalHeader>
			<ModalBody>
				<input ref={uploadFile} onChange={handleFiles} type="file" className='block mb-2' />
				<Alert type='warning' description="Alerta: Si un código ya existe para un mismo usuario se actualizará el resto de datos asociados." />
				<Button 
					color="primary" 
					onClick={handleSubmit} 
					disabled={!data || loading}
					className="mt-2"
				>
					Importar Bonos de Regalo{" "}
					{ loading && <Spinner size="sm" className='ml-3' /> }
				</Button>
				<div className='mt-2 p-2 bg-light'>
					<ol>
						{ results.length > 0 && (
							<React.Fragment>
								{ results.map((result, i) => (
									<li key={i}>
										<strong>Fila #0{result.row}: </strong>{result.comment}
									</li>
								))}
							</React.Fragment>
						)}
					</ol>
				</div>
			</ModalBody>
		</Modal>
	)
}